// extracted by mini-css-extract-plugin
module.exports = {"draft":"Draft_draft__15Qc2","title":"Draft_title__2IsZK","button":"Draft_button__1guQV"};